import { createReducer } from '@reduxjs/toolkit';
import t from '@/store/types';

// Initial state.
const initialState = {
  balanceSheet: {
    displayFilterDrawer: false,
  },
  trialBalance: {
    displayFilterDrawer: false,
  },
  generalLedger: {
    displayFilterDrawer: false,
  },
  journal: {
    displayFilterDrawer: false,
  },
  profitLoss: {
    displayFilterDrawer: false,
  },
  ARAgingSummary: {
    displayFilterDrawer: false,
  },
  APAgingSummary: {
    displayFilterDrawer: false,
  },
  purchasesByItems: {
    displayFilterDrawer: false,
  },
  salesByItems: {
    displayFilterDrawer: false,
  },
  inventoryValuation: {
    displayFilterDrawer: false,
  },
  customersBalanceSummary: {
    displayFilterDrawer: false,
  },
  vendorsBalanceSummary: {
    displayFilterDrawer: false,
  },
  customersTransactions: {
    displayFilterDrawer: false,
  },
  vendorsTransactions: {
    displayFilterDrawer: false,
  },
  cashFlowStatement: {
    displayFilterDrawer: false,
  },
  inventoryItemDetails: {
    displayFilterDrawer: false,
  },
  realizedGainOrLoss: {
    displayFilterDrawer: false,
  },
  unrealizedGainOrLoss: {
    displayFilterDrawer: false,
  },
  projectProfitabilitySummary: {
    dispalyFilterDrawer: false,
  },
  salesTaxLiabilitySummary: {
    displayFilterDrawer: false,
  },
};

/**
 * Financial statement filter toggle.
 */
const financialStatementFilterToggle = (financialName: any, statePath: any) => {
  return {
    [`${financialName}/${t.DISPLAY_FILTER_DRAWER_TOGGLE}`]: (
      state: any,
      action: any,
    ) => {
      state[statePath].displayFilterDrawer =
        typeof action?.payload?.toggle !== 'undefined'
          ? action.payload.toggle
          : !state[statePath].displayFilterDrawer;
    },
  };
};

export default createReducer(initialState, (builder) => {
  const addToggleCase = (financialName: any, statePath: any) => {
    Object.entries(
      financialStatementFilterToggle(financialName, statePath),
    ).forEach(([actionType, reducer]) => {
      builder.addCase(actionType, reducer as any);
    });
  };

  addToggleCase(t.BALANCE_SHEET, 'balanceSheet');
  addToggleCase(t.TRIAL_BALANCE_SHEET, 'trialBalance');
  addToggleCase(t.JOURNAL, 'journal');
  addToggleCase(t.GENERAL_LEDGER, 'generalLedger');
  addToggleCase(t.PROFIT_LOSS, 'profitLoss');
  addToggleCase(t.AR_AGING_SUMMARY, 'ARAgingSummary');
  addToggleCase(t.AP_AGING_SUMMARY, 'APAgingSummary');
  addToggleCase(t.PURCHASES_BY_ITEMS, 'purchasesByItems');
  addToggleCase(t.SALES_BY_ITEMS, 'salesByItems');
  addToggleCase(t.INVENTORY_VALUATION, 'inventoryValuation');
  addToggleCase(t.CUSTOMERS_BALANCE_SUMMARY, 'customersBalanceSummary');
  addToggleCase(t.VENDORS_BALANCE_SUMMARY, 'vendorsBalanceSummary');
  addToggleCase(t.CUSTOMERS_TRANSACTIONS, 'customersTransactions');
  addToggleCase(t.VENDORS_TRANSACTIONS, 'vendorsTransactions');
  addToggleCase(t.CASH_FLOW_STATEMENT, 'cashFlowStatement');
  addToggleCase(t.INVENTORY_ITEM_DETAILS, 'inventoryItemDetails');
  addToggleCase(t.REALIZED_GAIN_OR_LOSS, 'realizedGainOrLoss');
  addToggleCase(t.UNREALIZED_GAIN_OR_LOSS, 'unrealizedGainOrLoss');
  addToggleCase(t.PROJECT_PROFITABILITY_SUMMARY, 'projectProfitabilitySummary');
  addToggleCase(t.SALES_TAX_LIABILITY_SUMMARY, 'salesTaxLiabilitySummary');
});
